/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StrategieMaschinenAuslastung
 */
export interface StrategieMaschinenAuslastung {
    /**
     * ID-Name der Maschinengruppe
     * @type {string}
     * @memberof StrategieMaschinenAuslastung
     */
    maschinenGruppe: string;
    /**
     * Jahr für welches die Auslastung gilt
     * @type {number}
     * @memberof StrategieMaschinenAuslastung
     */
    jahr: number;
    /**
     * Die angegebene Auslastung für ein Kalenderjahr
     * @type {number}
     * @memberof StrategieMaschinenAuslastung
     */
    wert: number;
}

/**
 * Check if a given object implements the StrategieMaschinenAuslastung interface.
 */
export function instanceOfStrategieMaschinenAuslastung(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "maschinenGruppe" in value;
    isInstance = isInstance && "jahr" in value;
    isInstance = isInstance && "wert" in value;

    return isInstance;
}

export function StrategieMaschinenAuslastungFromJSON(json: any): StrategieMaschinenAuslastung {
    return StrategieMaschinenAuslastungFromJSONTyped(json, false);
}

export function StrategieMaschinenAuslastungFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategieMaschinenAuslastung {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maschinenGruppe': json['maschinenGruppe'],
        'jahr': json['jahr'],
        'wert': json['wert'],
    };
}

export function StrategieMaschinenAuslastungToJSON(value?: StrategieMaschinenAuslastung | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maschinenGruppe': value.maschinenGruppe,
        'jahr': value.jahr,
        'wert': value.wert,
    };
}

